import { StateManager } from '../stateManager';

import { SET_HANDOVER_DATA } from './actions';

export const initialState = {
  handoverData: null,
};

const setHandoverData = (state, action) => {
  let { data } = action;
  return { ...state, handoverData: data };
};

const actions = {
  [SET_HANDOVER_DATA]: setHandoverData,
};

const manager = new StateManager(initialState, actions);

export default manager.reducer;
